import React from 'react';

const mapEmbed =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.188265099758!2d75.82201781504466!3d26.89751958313415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xce1fe87a942b37bb!2sRaj+Printers+%26+Associates!5e0!3m2!1sen!2sin!4v1542214686218';

function ContactSection() {
    return (
        <section id="contact" className="bd-contact">
            <div className="bd-contact__grid">
                <div className="bd-contact__card">
                    <div>
                        <div className="bd-catalogue__eyebrow" style={{ color: 'inherit', opacity: 0.85 }}>
                            ◆ 03 / Visit us
                        </div>
                        <h2 className="bd-contact__h2">
                            Come for chai,<br />
                            <em>leave with print.</em>
                        </h2>
                    </div>
                    <div className="bd-contact__details">
                        <div>
                            <div className="bd-contact__label">Call</div>
                            <div className="bd-contact__value">
                                <a href="tel:+919982066620">+91 99820 666 20</a><br />
                                <a href="tel:+919413341382">+91 94133 413 82</a><br />
                                <a href="tel:+918233661639">+91 82336 616 39</a>
                            </div>
                        </div>
                        <div>
                            <div className="bd-contact__label">Mail</div>
                            <div className="bd-contact__value">
                                <a href="mailto:rajprinters81@gmail.com">
                                    rajprinters81<br />@gmail.com
                                </a>
                            </div>
                            <div className="bd-contact__label" style={{ marginTop: 24 }}>Address</div>
                            <div className="bd-contact__address">
                                Basement 43–44, Govind Marg,<br />
                                Gurunanakpura, Raja Park,<br />
                                Jaipur, Rajasthan 302004
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bd-map">
                    <iframe
                        src={mapEmbed}
                        title="Raj Printers & Associates location"
                        loading="lazy"
                        allowFullScreen
                    />
                    <div className="bd-map__pill">
                        <div>
                            <div className="bd-map__pin-label">Pin · 26.9098° N · 75.8378° E</div>
                            <div className="bd-map__name">Govind Marg, Raja Park</div>
                        </div>
                        <a
                            href="https://goo.gl/maps/NWfRvrmZGUU2"
                            target="_blank"
                            rel="noreferrer"
                            className="bd-map__btn"
                        >
                            Open in Maps ↗
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactSection;
